import type { CustomerMeasurementSummary } from '@optiflow/types';

/** Only a person's own active measurement of a PD can go on a prescription; camera estimates and validation data never can, and the API refuses them too. */
export function isPrescribablePd(measurement: CustomerMeasurementSummary): boolean {
  return (
    measurement.status === 'ACTIVE' &&
    measurement.pdType !== null &&
    !measurement.referenceOnly &&
    !measurement.isValidation
  );
}
